module.exports = __webpack_public_path__ + "img/Differentiation-OVCA_10X_TPCP.3bb6cdba.png";